/**
 * Огрублённый отпечаток устройства.
 *
 * Нужен для одной задачи: склеить заходы с одного устройства, когда кука
 * потеряна. Человека он не опознаёт и опознавать не должен — берутся только
 * общедоступные и грубые признаки, по которым отдельного человека не выделить.
 * Точная привязка появляется только при входе, через связку с пользователем.
 */
function fnv1a(value: string): string {
  let hash = 0x811c9dc5;
  for (let i = 0; i < value.length; i += 1) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash.toString(16).padStart(8, "0");
}

export function deviceHash(): string {
  const nav = navigator;
  const screenSize = `${screen.width}x${screen.height}x${window.devicePixelRatio || 1}`;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  const parts = [
    nav.userAgent,
    nav.language,
    (nav as unknown as { platform?: string }).platform || "",
    screenSize,
    timezone,
    String((nav as unknown as { hardwareConcurrency?: number }).hardwareConcurrency || ""),
  ];
  // Двойной прогон даёт 16 знаков — достаточно, чтобы группировать, и мало,
  // чтобы выделять конкретного человека.
  const joined = parts.join("|");
  return fnv1a(joined) + fnv1a(joined.split("").reverse().join(""));
}
